import * as types from '../../../actions/candidate/candidate-application-draft/types';
import Immutable from 'immutable';
import reducerCreator from '../../../tools/reducer-creator';

const initialState = Immutable.fromJS({
  applicationDraftState: null,
  isApplicationDraftLoading: false,
  isApplicationCanceling: false,
  isApplicationCoverLetterUpdating: false,
  isApplicationSupplementaryQuestionsUpdating: false,
  applicationHasBeenCanceled: false,
  isApplicationSubmitting: false,
  applicationHasBeenSubmitted: false
});

export default reducerCreator(initialState, {
  [types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_DRAFT_STATE]: (state, { applicationDraftState }) =>
    state.set('applicationDraftState', applicationDraftState),

  [types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_DRAFT_LOADING]: (state, { isApplicationDraftLoading }) =>
    state.set('isApplicationDraftLoading', isApplicationDraftLoading),

  [types.CANDIDATE_APPLICATION_SET_COVER_LETTER_UPDATING]: (state, { isLoading }) =>
    state.set('isApplicationCoverLetterUpdating', isLoading),
  
  [types.CANDIDATE_APPLICATION_SET_SUPPLEMENTARY_QUESTIONS_UPDATING]: (state, { isLoading }) =>
    state.set('isApplicationSupplementaryQuestionsUpdating', isLoading),

  [types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_CANCELING]: (state, { isApplicationCanceling }) =>
    state.set('isApplicationCanceling', isApplicationCanceling),

  [types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_HAS_BEEN_CANCELED]: (state, { applicationHasBeenCanceled }) =>
    state.set('applicationHasBeenCanceled', applicationHasBeenCanceled),

  [types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_SUBMITTING]: (state, { isApplicationSubmitting }) =>
    state.set('isApplicationSubmitting', isApplicationSubmitting),

  [types.CANDIDATE_APPLICATION_DRAFT_SET_APPLICATION_HAS_BEEN_SUBMITTED]: (state, { applicationHasBeenSubmitted }) =>
    state.set('applicationHasBeenSubmitted', applicationHasBeenSubmitted),

  [types.CANDIDATE_APPLICATION_DRAFT_RESET_APPLICATION_DRAFT_STATE]: () =>
    initialState,
});


// WEBPACK FOOTER //
// ./src/reducers/candidate/candidate-application/candidate-application-draft.js